import { useCookies } from "react-cookie"

const useThemeCookie = () => {

    const cookieName = "TTC1"
    const [cookie, setCookie, removeCookie] = useCookies([cookieName])

    const createCookie = (theme) => {
        setCookie(cookieName, theme, {
            "path": "/",
            // "sameSite": "none",
            // "secure": true,
        })
    }

    const deleteCookie = () => {
        removeCookie(cookieName, { "path": "/" })
    }

    return [cookie[cookieName], createCookie, deleteCookie]
}

export default useThemeCookie

export const BASIC = 1
export const GRADATION = 2
export const TRANSPARENCY = 3